import { useFeature } from 'common/hooks/useFeature';
import FEATURES from 'src/core/constants/features';

import { useGetPurchaseOrdersSettings } from './useGetPurchaseOrderSettings';

export const usePurchaseOrderSettings = () => {
  const { data: purchaseOrdersSettings } = useGetPurchaseOrdersSettings();
  const hasSendPurchaseOrderPdfEmailToSupplier = useFeature(
    FEATURES.SEND_PURCHASE_ORDER_PDF_EMAIL_TO_SUPPLIER,
  );

  return {
    settings: purchaseOrdersSettings,
    hasSendPurchaseOrderPdfEmailToSupplier,
  };
};
